import {throwIfUndefined} from '@coolcolduk/util';
import type {QuizSession, QuizSessionWrite} from '@cp/model';
import {useCallback} from 'react';
import createQuizSessionDoc from '../../api/quizSession/createQuizSessionDoc';
import getQuizSessionDoc from '../../api/quizSession/getQuizSessionDoc';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export default function useCreateQuizSession() {
  const createFn = useCallback(async (payload: QuizSessionWrite): Promise<QuizSession> => {
    const uid = await getCurrentUserIdValidated();
    const session = await createQuizSessionDoc(uid, payload);
    const doc = await getQuizSessionDoc(uid, session.id);
    return throwIfUndefined(doc, 'Session not found') as unknown as QuizSession;
  }, []);

  const {fn, loading, error} = useFunctionWrap(createFn);

  return {
    createQuizSession: fn,
    loading,
    error,
  };
}
